import { gql } from "@apollo/client";

export const FETCH_VIDEO_BY_EPISODE = gql`
  query FetchVideoByEpisode($episode_id: UUID!) {
    fetchVideoByEpisode(episode_id: $episode_id) {
      data {
        video {
          created_at
          featured
          id
          identifier
          otp
          playback_info
          season_folder_id
          title
          updated_at
          upload_status
          video
          visibility
          thumbnail
          packages {
            updated_at
            id
            package_id
            content_type
            ref_id
            created_at
            package {
              id
              name
              description
              package_type
              created_at
              updated_at
            }
          }
          category {
            created_at
            description
            folder_id
            id
            name
            group_id
          }
          episode {
            episode_number
            id
            label
            season_id
            series_id
          }
        }
        clientPayload {
          key
          policy
          uploadLink
          video_id
          x_amz_algorithm
          x_amz_credential
          x_amz_date
          x_amz_signature
        }
      }
      error {
        code
        field
        message
      }
    }
  }
`;

export const FETCH_ALL_VIDEO = gql`
  query FetchAllVideos {
    fetchAllVideos {
      data {
        videos {
          created_at
          featured
          id
          identifier
          otp
          playback_info
          season_folder_id
          title
          updated_at
          upload_status
          video
          visibility
          packages {
            updated_at
            id
            package_id
            content_type
            ref_id
            created_at
            package {
              id
              name
              description
              package_type
              created_at
              updated_at
            }
          }
          category {
            created_at
            description
            folder_id
            group_id
            id
            name
            updated_at
          }
          episode {
            created_at
            episode_number
            id
            label
            season_id
            series_id
            updated_at
          }
        }
      }
      error {
        code
        field
        message
      }
    }
  }
`;
export const FETCH_VIDEO_VIEWS = gql`
  query FetchVideoViews {
    fetchVideoViews {
      data {
        video_views {
          count
          created_at
          id
          updated_at
          user_id
          video_id
        }
      }
      error {
        code
        field
        message
      }
    }
  }
`;

export const FETCH_PACKAGE_BY_REF_ID = gql`
  query FetchPackageByRefId($ref_id: UUID!, $content_type: String) {
    fetchPackageByRefId(ref_id: $ref_id, content_type: $content_type) {
      data {
        package_content {
          id
          package_id
          content_type
          ref_id
          created_at
          updated_at
          package {
            id
            name
            description
            package_type
            created_at
            updated_at
          }
        }
      }
      error {
        message
        code
        field
      }
    }
  }
`;


export const SET_VIDEO_TO_ANOTHER_GROUP = gql`
 query SetVideoToAnotherGroup($input: SetVideoInput!, $video_id: UUID!) {
    setVideoToAnotherGroup( input: $input, video_id: $video_id) {
        data {
            video {
                featured
                season_folder_id
                id
                upload_status
                video
                created_at
                updated_at
                identifier
                otp
                thumbnail
                title
                playback_info
                visibility
                category {
                    group_id
                    folder_id
                    id
                    description
                    created_at
                    category_order
                    updated_at
                    name
                    group {
                        updated_at
                        id
                        folder_id
                        image
                        description
                        name
                        group_order
                        created_at
                        icon
                    }
                }
                packages {
                    id
                    package_id
                    content_type
                    ref_id
                    created_at
                    updated_at
                    package {
                        package_type
                        created_at
                        updated_at
                        id
                        name
                        description
                    }
                }
                episode {
                    id
                    label
                    season_id
                    series_id
                    episode_number
                    created_at
                    updated_at
                }
            }
        }
        error {
            message
            code
            field
        }
    }
}

`;
